// constants.js
export const PATH = {
  userProfileSelectionPath: "/user-profile-selection",
  rentalTextileLaundryPath: "/rental-textile-laundry",
  frClothingPath: "/fr-clothing",
};


export const USER_PROFILE_SECTION = {
  INFO_TEXT: "Come and put Nomex® Comfort with EcoForce™ to the test and check if it could help to have a positive impact on:",
  INFO_TEXT_2: "You will find in each section the base metrics for each calculation.",
  LIST_ITEMS: [
    "Cost over time",
    "Energy and operational footprint",
    "The environment",
  ],
  SELECT_COUNTRY_TEXT: "Select your Country",
  SELECT_ROLE_TEXT: "Select your Role",
  SELECT_UNIT_TEXT: "Select your Unit",
  SELECT_INDUSTRY_TEXT: "Select your Industry",
 
  RENTAL_TEXTILE_LAUNDRY_PROFILE: "rental-textile-laundry",
  FR_CLOTHING_PROFILE: "FR-Clothing",
  COUNTRIES: ["Country 1", "Country 2"],
  ROLES: ["Role 1", "Role 2"],
  UNITS: ["Unit 1", "Unit 2"],
  INDUSTRIES: ["Industry 1", "Industry 2"],
};

export const CUSTOM_APP_BAR_TEXT = {
  ESTIMATED_COST: ' Estimated cost over time',
  ENERGY_AND_OPERATIONAL_FOOTPRINT: 'Energy and operational footprint',
  ENVIRONMENT: 'Environmental impact',
  ENERGY_EFFICIENCY: 'Energy Efficiency'
}

export const RENTAL_TEXTILE_LAUNDRY = {
  HOME_LABEL: 'Home',
  USER_PROFILE_SELECTION_LABEL: 'User Profile Selection',
  RENTAL_TEXTILE_LAUNDRY_LABEL: 'Rental Textile Laundry',
  SELECT_CURRENCY_TEXT: 'Select Currency',
  COST_OF_REIMPREGNATION_LABEL: 'Cost of reimpregnation per wash per garment',
  YEARLY_VOLUME_LABEL: 'Yearly volume of garments being re-impregnated',
  OVER_100_CLEANING_CYCLES_LABEL: 'Over 100 cleaning cycles',
  EACHES_PER_YEAR_DEFAULT_VALUE: 'eaches / year',
  EACHES_DEFAULT_VALUE: 'eaches',
  OVERALL_COST_TITLE: 'Overall cost of repellency treatment re-impregnation over 100 cleaning cycles',
  POTENTIAL_SAVINGS_TITLE: 'Potential savings linked to energy efficiency over 100 cleaning cycles',
  CALCULATE_BUTTON_TEXT: 'Calculate',
  INFO_TEXT_COST_FOCUS: 'Cost is not only about the one-time purchase of a product anymore but the overall cost over its lifetime, especially as durability is a key focus area for textiles driven by EU Green deal.',
  INFO_TEXT_PROCESS_EFFICIENCY: 'Process efficiency is key to make savings.',
  INFO_TEXT_SUSTAINABILITY: 'When it comes to improving sustainability and the impact on the environment, Nomex® Comfort with Ecoforce delivers. Discover now how ',
  NOMEX_CERTIFICATION_INFO: 'Nomex Comfort with EcoForce™ is certified after 100 cycles to EN 11612, EN 1149-5, EN 13034.',
  DISCOVER_NOMEX_EFFICIENCY: 'Discover if Nomex® Comfort with Ecoforce can help to reduce energy consumption and improve operational footprint ',
  DISCOVER_NOMEX_DURABILITY: 'Discover if Nomex® Comfort with EcoForce™ outstanding durability can help to minimize cost over time ',
  ACCORDIAN_TEXT: 'In the industry, when it comes to FR solutions that have a chemical repellent finish, common practice is to re-impregnate the treatment very frequently as its durability cannot be proven. This can result in high costs linked to re-impregnation. Nomex® Comfort with EcoForce™ is engineered for long-term chemical repellency properties and its composition does not contain any fluorine chemistry.',
  ACCORDIAN_TEXT_BOLD: 'It has been certified after x100 cleaning cycles under industrial conditions (EN 15797) without re-applying the repellent finish.',
  CHECK_SAVINGS_TEXT: 'Check how much you could save by not re-applying the treatment after each wash: ',
  POTENTIAL_SAVINGS_ACCORDIAN_TEXT: 'Nomex® Comfort with EcoForce™ can be effectively washed and dried at 60°C/140°F',
  POTENTIAL_SAVINGS_ACCORDIAN_TEXT_BOLD: 'Check out how this compares to other solutions and if it can help you save energy costs:',
  SELECT_COUNTRY_TEXT: 'Select Country',
  RECOMMENDED_WASH_TEMP: 'Recommended washing temperature (°C):',
  POTENTIAL_SAVINGS_HEADERS: [
  'Nomex® Comfort with EcoForce™',
  'Your incumbent Solution 1',
  'Your incumbent Solution 2',
  'Your incumbent Solution 3',
  'Your incumbent Solution 4',
  ],

  tabTexts: {
    0: {
      p1: "Cost is not only about the one-time purchase of a product anymore but the overall cost over its lifetime, especially as durability is a key focus area for textiles driven by EU Green deal.",
      p2: "Nomex Comfort with EcoForce™ is certified after 100 cycles to EN 11612, EN 1149-5, EN 13034.",
      p3: "Discover if Nomex® Comfort with EcoForce™ outstanding durability can help to minimize cost over time "
    },
    1: {
      p1: "Process efficiency is key to make savings.",
      p2: "Discover if Nomex® Comfort with Ecoforce can help to reduce energy consumption and improve operational footprint ",
      p3: ""
    },
    2: {
      p1: "When it comes to improving sustainability and the impact on the environment, Nomex® Comfort with Ecoforce delivers. Discover now how ",
      p2: "",
      p3: ""
    }
  },

  OPERATIONAL_FOOTPRINT_ACCORDIAN_TEXT: 'Nomex® Comfort with EcoForce™ fabric is extremely lightweight, yet performant. It is available in 204g/m² and 224g/m² when most FR solutions weigh 300g/m2 on average.',
  OPERATIONAL_FOOTPRINT_ACCORDIAN_TEXT_BOLD:'Check how this can impact your productivity during your washing and cleaning processes:',
  ENERGY_EFFICIENCY_ACCORDIAN_TEXT: 'Compare your current solution with Nomex® Comfort with EcoForce™ and check if it can help you to have a positive impact on:',
  ENVIRONMENTAL_IMPACT_ACCORDIAN_TEXT: 'Check how much chemicals you can save when you consider a durable solution that does not require frequent chemical repellency treatment re-impregnation, like Nomex® Comfort with EcoForce™:',
};

export const FR_CLOTHING = {
  OVERALL_COST_TITLE: 'Overall cost of ownership over 100 cleaning cycles',
  OVERALL_COST_DESCRIPTION: 'Cost is not about the one-time purchase of a product anymore but implies the overall cost over the lifetime of the product, especially as durability is becoming a focal area of improvement for textiles.',
  OVERALL_COST_SUBTITLE: 'Discover if Nomex® Comfort with EcoForce™ outstanding durability can help to minimize cost over time ',
  OVERALL_COST_LABELS: [
    'Enter fabric name and composition:',
    'Select currency:',
    'Cost of purchase of 1 garment OR leasing price:',
    '# of wearers:',
    'Avg # of purchase + replacement over 100 cleaning cycles:'
  ],
  REIMPREGNATION_DESCRIPTION: 'In the industry, when it comes to FR solutions that have a chemical repellent finish, common practice is to re-impregnate the treatment very frequently as its durability cannot be proven. This can result in high costs linked to re-impregnation.',
  REIMPREGNATION_SUBTITLE_TEXT:'Nomex® Comfort with EcoForce™ is engineered for long-term chemical repellency properties and its composition does not contain any fluorine chemistry. It has been certified after x100 cleaning cycles under industrial conditions (EN 15797) without re-applying the repellent finish.',
  tabTexts: {
    0: {
      p1: "Cost is not only about the one-time purchase of a product anymore but the overall cost over its lifetime, especially as durability is a key focus area for textiles driven by EU Green deal.",
      p3: "Discover if Nomex® Comfort with EcoForce™ outstanding durability can help to minimize cost over time "
    },
    1: {

    },
    2: {
      p1: "When it comes to improving sustainability and the impact on the environment, Nomex® Comfort with Ecoforce delivers. Discover now how ",
      p2: "",
      p3: ""
    }
  },
}

export const CURRENCIES = [
  {
    value: 'USD',
    label: '$',
  },
  {
    value: 'EUR',
    label: '€',
  },
  {
    value: 'BTC',
    label: '฿',
  },
  {
    value: 'JPY',
    label: '¥',
  },
];

export const COUNTRIES=[
  {
    value: 'USA',
    label: 'United States',
  },
  {
    value: 'GER',
    label: 'Germany',
  },
  {
    value: 'JP',
    label: 'Japan',
  },
  {
    value: 'IT',
    label: 'Italy',
  },
];
